import { call, put, takeEvery } from 'redux-saga/effects';
import { getWetLogsByDeviceIdAPI } from '../api/logAPI';
import { LOG } from "../actions/log";
import LogConverter from '../models/logs/logConverter';

/*************************** CALLS ***************************/

export function* fetchDeviceWetLogsCall(action) {
  try {
    const deviceId = action.payload.data;
    const response = yield call(getWetLogsByDeviceIdAPI, deviceId);
    const data = LogConverter.fromAPILogsResponse(response);
    yield put({ type: LOG.SET_ALL, payload: {data: data} });
    console.info("[logs.saga fetch logs by device]: ", data);
  }
  catch (error) {
    console.info("[logs.saga fetch logs by device] error: ", error);
    yield put({ type: LOG.SET_ALL, payload: {data: null} });
    yield put({type: LOG.FETCH_ALL_FAILED});
  }
}

/*************************** WATCH ***************************/

export function* fetchDeviceWetLogsWatch() {
  yield takeEvery(LOG.FETCH_ALL, fetchDeviceWetLogsCall);
}


// WEBPACK FOOTER //
// ./src/sagas/log.js